// @flow
import * as React from 'react';
import { useSelector } from 'react-redux';
import { getIsLandingTab, getIsLandingTabInSameBrowser } from 'esm-web-pro/redux/landingTab';
import { getUser } from 'speed-js-react';
import { v4 as uuidv4 } from 'uuid';

export const FOCUSED_TAB_LC_KEY = 'focused-tabs';

export const getTabId = () => {
    let tabId = window.sessionStorage.getItem('tabId');
    if (tabId) {
        return tabId;
    }
    tabId = uuidv4();
    window.sessionStorage.setItem('tabId', tabId);
    return tabId;
};

const FocusedTabsController = () => {
    const isLandingTab = useSelector(getIsLandingTab);
    const isLandingTabInSameBrowser = useSelector(getIsLandingTabInSameBrowser);
    const user = useSelector(getUser);

    const tabId = React.useMemo(getTabId);

    const handleVisibilityChange = React.useCallback(() => {
        const lcFocusedTabs = window.localStorage.getItem(FOCUSED_TAB_LC_KEY);
        if (lcFocusedTabs) {
            const focusedTabs = JSON.parse(lcFocusedTabs);
            if (document.visibilityState === 'visible') {
                window.localStorage.setItem(FOCUSED_TAB_LC_KEY, JSON.stringify([...new Set([...focusedTabs, tabId])]));
            } else {
                window.localStorage.setItem(FOCUSED_TAB_LC_KEY, JSON.stringify(
                    focusedTabs.filter((tab) => tab !== tabId),
                ));
            }
        } else if (document.visibilityState === 'visible') {
            window.localStorage.setItem(FOCUSED_TAB_LC_KEY, JSON.stringify([tabId]));
        }
    }, [tabId]);

    React.useEffect(() => {
        if (user && (isLandingTab || isLandingTabInSameBrowser)) {
            if (document.visibilityState === 'visible') {
                handleVisibilityChange();
            }
            document.addEventListener('visibilitychange', handleVisibilityChange);
        }
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [user, handleVisibilityChange, isLandingTabInSameBrowser, isLandingTab]);

    return null;
};

export default FocusedTabsController;
